import { render, staticRenderFns } from "./HeaderCalendar.vue?vue&type=template&id=49a24a41&scoped=true"
import script from "./HeaderCalendar.vue?vue&type=script&lang=js"
export * from "./HeaderCalendar.vue?vue&type=script&lang=js"
import style0 from "./HeaderCalendar.vue?vue&type=style&index=0&id=49a24a41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a24a41",
  null
  
)

export default component.exports